import { render, staticRenderFns } from "./ActionLink.vue?vue&type=template&id=6bc1b353&scoped=true&"
import script from "./ActionLink.vue?vue&type=script&lang=ts&"
export * from "./ActionLink.vue?vue&type=script&lang=ts&"
import style0 from "./ActionLink.vue?vue&type=style&index=0&id=6bc1b353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc1b353",
  null
  
)

export default component.exports